import API from '../../services/API';

import { setError, startSpinner, stopSpinner } from '../common/actionCreators';
import { configs } from '../../constants/configs/configs';
import { SPINNER_MESSAGES_IDS } from '../../constants/common/miscellaneous';

const actions = { setError, startSpinner, stopSpinner };

export const sendOtp =
    ({ payload }) =>
        async (dispatch: Function) => {
            dispatch(startSpinner(SPINNER_MESSAGES_IDS.LOADING_DATA));
            const url = configs.endpoints.SEND_OTP;
            const params = [
                url,
                payload,
                'POST',
                false,
                undefined,
                'application/json',
                true,
                false,
                false,
                SPINNER_MESSAGES_IDS.LOADING_DATA,
            ];

            try {
                const data = await API.postData(params, dispatch, actions);

                if (!data) {
                    console.error('Cannot send otp', url);
                    return null;
                }
                return data;
            } catch (error) {
                console.error('Cannot send otp', url);
                return null;
            } finally {
                dispatch(stopSpinner());
            }
        };

export const verifyOTP =
    ({ payload }) =>
        async (dispatch: Function) => {
            dispatch(startSpinner(SPINNER_MESSAGES_IDS.LOADING_DATA));
            const url = configs.endpoints.VERIFY_OTP;
            const params = [
                url,
                payload,
                'POST',
                true,
                undefined,
                'application/json',
                true,
                false,
                false,
                SPINNER_MESSAGES_IDS.LOADING_DATA,
            ];
            try {
                const data = await API.postData(params, dispatch, actions);

                if (!data) {
                    console.error('Cannot verify otp', url);
                    return null;
                }
                return data;
            } catch (error) {
                console.error('Cannot verify otp', url);
                return null;
            } finally {
                dispatch(stopSpinner());
            }
        };
